import React, { useState, useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";
// Icons from lucide-react
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 2000, // Smooth sliding transition (in ms)
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Allow scrolling one slide at a time
    arrows: false,
    swipeToSlide: true, // This makes the scroll feel more natural (free scroll)
    draggable: true, // Allows dragging for free scroll
    touchMove: true, // Enables touch-based scrolling
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2, // Show 2 slides at smaller screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // Show 1 slide at very small screens
          slidesToScroll: 1,
        },
      },
    ],
  };

  const sliderRef = useRef(null);
  const [intervalId, setIntervalId] = useState(null);

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const startSliding = (direction) => {
    // If an interval is already running, stop it
    if (intervalId) {
      clearInterval(intervalId);
    }

    // Start a new interval based on the direction
    const id = setInterval(() => {
      direction === "left" ? handlePrev() : handleNext();
    }, 300); // Adjust the interval time for speed (300ms per slide)

    setIntervalId(id);
  };

  const stopSliding = () => {
    // Clear the interval when the mouse leaves
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  };

  return (
    <SliderWrapper>
      <div className="hidden md:block">
        <ArrowWrapper
          onMouseEnter={() => startSliding("left")} // Start sliding left
          onMouseLeave={stopSliding} // Stop sliding when mouse leaves
          className="left-arrow"
        >
          <ArrowLeft size={24} />
        </ArrowWrapper>
      </div>
      <Slider ref={sliderRef} {...settings}>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Grâce à ces formations, j'ai pu développer de nouvelles compétences qui ont véritablement boosté ma carrière !"
            author="Isabelle T., participante à la formation"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Le service client est tout simplement exceptionnel. Toujours réactifs et prêts à résoudre mes problèmes, je me sens soutenu à chaque étape."
            author="Antoine G., fidèle auditeur"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Les émissions proposées sont de loin les plus enrichissantes que j'ai écoutées. Un contenu de qualité qui inspire chaque jour !"
            author="Camille L., auditrice"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Je ne me lasse jamais des formations proposées. Chaque session est bien pensée et adaptée à mes besoins. Un apprentissage qui fait la différence !"
            author="Éric M., apprenant"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Quand on parle de qualité, rien ne vaut ce service. Leur support m’a toujours apporté des solutions rapides et efficaces."
            author="Lucie F., auditrice"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Les formations sont incroyablement bien structurées. Grâce à cette plateforme, j’ai pu faire passer mes compétences au niveau supérieur."
            author="Mathieu P., participant à la formation"
          />
        </LogoWrapper>
      </Slider>
      <div className="hidden md:block">
        <ArrowWrapper
          onMouseEnter={() => startSliding("right")} // Start sliding right
          onMouseLeave={stopSliding} // Stop sliding when mouse leaves
          className="right-arrow" // Hidden on small screens, shown on large
        >
          <ArrowRight size={24} />
        </ArrowWrapper>
      </div>
    </SliderWrapper>
  );
}

const SliderWrapper = styled.div`
  position: relative;
  .slick-slide {
    transition: transform 0.7s ease-in-out; // Smooth transition for slide movement
  }
`;

const LogoWrapper = styled.div`
  width: 100%; // Ensures the slide takes up full available width
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;

const ArrowWrapper = styled.div`
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 10px;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
  &.left-arrow {
    left: 0;
    transform: translateY(-50%);
    transform: translateX(-50%);
  }
  &.right-arrow {
    right: 0;
    transform: translateY(-50%);
    transform: translateX(50%);
  }
`;
